import React from 'react';
import {classes, style} from './doppe-page-privacy-and-terms-view.st.css';
import {useDoppeViewerLocales} from "../../client/doppe-viewer-locales/doppe-viewer-locales";
import {
    evaluateFunction,
    stringIsNotNullableOrWhiteSpace,
    stringReplaceEmptyOrWhiteSpaceValue
} from "@wix/devzai-utils-common";
import {
    useDoppeViewerPrivacyAndTermsForDisplay
} from "../doppe-viewer-bymo-page-props-react/doppe-viewer-bymo-page-props-react";

export const DoppePagePrivacyAndTermsView = React.memo(function DoppePagePrivacyAndTermsView(
    props: DoppePagePrivacyAndTermsView.Props
) {
    const {
        showHoppBrandedMessage = false,

        className,
        ...htmlAttributes
    } = props;

    const privacyAndTermsForDisplay = useDoppeViewerPrivacyAndTermsForDisplay();

    const doppeViewerLocales = useDoppeViewerLocales();

    if (privacyAndTermsForDisplay) {

        const {
            userTermsOfServiceUrl,
            userPrivacyPolicyUrl,
            userDisplayName
        } = privacyAndTermsForDisplay;

        return (
            <div
                className={style(classes.root, className)}
                {...htmlAttributes}
            >
                {showHoppBrandedMessage ? doppeViewerLocales.$html(evaluateFunction(() => {
                    if (stringIsNotNullableOrWhiteSpace(userTermsOfServiceUrl) && stringIsNotNullableOrWhiteSpace(userPrivacyPolicyUrl)) {
                        return 'pageTermsOfServiceAndPrivacyPolicy.termsOfServiceAndPrivacyPolicy';
                    } else if (stringIsNotNullableOrWhiteSpace(userTermsOfServiceUrl)) {
                        return 'pageTermsOfServiceAndPrivacyPolicy.termsOfServiceOnly';
                    } else {
                        return 'pageTermsOfServiceAndPrivacyPolicy.privacyPolicyOnly'
                    }
                }), {
                    displayName: userDisplayName,
                    tagRenderFunctions: {
                        terms: (text) => {
                            return (
                                <a
                                    href={stringReplaceEmptyOrWhiteSpaceValue(userTermsOfServiceUrl, '#')}
                                    target={'_blank'}
                                    rel={'noreferrer'}
                                >
                                    {text}
                                </a>
                            )
                        },
                        privacy: (text) => {
                            return (
                                <a
                                    href={stringReplaceEmptyOrWhiteSpaceValue(userPrivacyPolicyUrl, '#')}
                                    target={'_blank'}
                                    rel={'noreferrer'}
                                >
                                    {text}
                                </a>
                            )
                        }
                    }
                }) : (
                    <>
                        <span>{doppeViewerLocales['pageTermsOfServiceAndPrivacyPolicy.genericMessage']}</span>
                        <span>{`:`}</span>
                        {stringIsNotNullableOrWhiteSpace(userTermsOfServiceUrl) ? (
                            <>
                                <span>{' '}</span>
                                <a
                                    href={userTermsOfServiceUrl}
                                    target={'_blank'}
                                    rel={'noreferrer'}
                                >
                                    {doppeViewerLocales['pageTermsOfServiceAndPrivacyPolicy.termsOfService']}
                                </a>
                            </>
                        ) : null}
                        {stringIsNotNullableOrWhiteSpace(userPrivacyPolicyUrl) ? (
                            <>
                                <span>{' '}</span>
                                <a
                                    href={userPrivacyPolicyUrl}
                                    target={'_blank'}
                                    rel={'noreferrer'}
                                >
                                    {doppeViewerLocales['pageTermsOfServiceAndPrivacyPolicy.privacyPolicy']}
                                </a>
                            </>
                        ) : null}
                    </>
                )}
            </div>
        );
    } else {
        return null;
    }
});

export namespace DoppePagePrivacyAndTermsView {

    export interface Props extends React.HTMLAttributes<any> {
        showHoppBrandedMessage?: boolean;
    }
}

